/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Style', function (){

        var  Style = function (label)
        {
            this.label = label;
        }

        return  Style;
    });
angular.module('FlexyBeautyApp.services').
    factory('StyleData',["Style", function (Style){
        var  styleData = {styles : []};

        styleData.get =  function(styleLabel)
        {
            for (var i=0;i<this.styles.length;i++)
                if (this.styles[i].label==styleLabel)
                    return this.styles[i];
            return null;
        }
        styleData.add =  function(image)
        {
            this.styles.push(image);
        }
        styleData.remove =  function(image)
        {
            var index =  this.styles.indexOf(image);
            if (index!=-1)
                this.styles.splice(index, 1);
        }
        styleData.clear =  function()
        {
            this.styles = [];
        }

        //INIT
        styleData.add(new Style("default"));//grey
        styleData.add(new Style("white"));
        styleData.add(new Style("black"));
        styleData.add(new Style("pink"));
        styleData.add(new Style("purple"));
        styleData.add(new Style("blue"));
        styleData.add(new Style("light-blue"));
        styleData.add(new Style("green"));
        styleData.add(new Style("yellow"));
        styleData.add(new Style("brown"));
        styleData.add(new Style("orange"));
        styleData.add(new Style("red"));

        return styleData;
    }]);


// WEBPACK FOOTER //
// ./js/services/modelsViews/Style.js